import { render, staticRenderFns } from "./cidetail.vue?vue&type=template&id=7c441e72&scoped=true"
import script from "./cidetail.vue?vue&type=script&lang=js"
export * from "./cidetail.vue?vue&type=script&lang=js"
import style0 from "./cidetail.vue?vue&type=style&index=0&id=7c441e72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c441e72",
  null
  
)

export default component.exports